/*=========================================================================================
  File Name: moduleInventoryState.js
  Description: Inventory Module State
==========================================================================================*/

export default {
	inventories: [],
	totalInventories: 0,
	showInventoryCategorySidebar: false,
	totalKCS: 0,
	kcsList: []
};
